define.alias("shared/components/shared/modal/navigation", "media/components/shared/modal/navigation");